import { generateEcondaString } from './useAnalyticsHelpers';
import { ApplicationEvent } from './analyticsTypes';

declare global {
  interface Window {
    fwaLayer: any;
  }
}

const fwaLayer = window.fwaLayer;

export const econdaClickEvent = (pathName: string, stepArea: string, elementName: string, elementValue: string) => {
  if (fwaLayer) {
    const dataType = 'applications';
    const applicationName = 'shock absorber';

    const econdaString = generateEcondaString({
      pathName,
      dataType,
      applicationName,
      stepArea,
      elementName,
      elementValue,
    });
    const applicationClickEvent: ApplicationEvent = {
      eventType: 'application',
      application: {
        type: 'click',
        elements: [econdaString],
      },
    };

    fwaLayer.sendChunks(applicationClickEvent);
  }
};

export function econdaEnhancedTracking(articleCode: string, arrayOfArticles: string[]) {
  if (fwaLayer) {
    const ecommerce = {
      eventType: 'view',
      article: [
        {
          articleCode: `${articleCode}`,
          articleOrderCodes: arrayOfArticles,
          productSeriesShortCode: 'unknown',
          articlePrice: 0,
          productGroup: 'unknown',
          count: 1,
          productProgram: 'unknown',
          articleType: 'unknown',
          articleStatus: 'unknown',
          productPlacement: 'primary',
          productSource: 'shock absorber',
          productTrackingId: 'unknown',
        },
      ],
    };
    fwaLayer.send(ecommerce);
  }
}
